import { Component, AfterViewInit } from '@angular/core';
// import { DirectLine, ConnectionStatus } from 'botframework-directlinejs';


// npm install botframework-webchat
// npm install botframework-directlinejs

@Component({
	selector: 'app-chatbot',
	templateUrl: './chatbot.component.html',
	styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent {
	isOpen = false;

	toggleChat() {
		this.isOpen = !this.isOpen;
	}

	async ngAfterViewInit() {
		const directLineSecret = "8vixt2O0GlO9PMOBQpwAXKsG76GlweNjp6zgesqcsCOiLwAP2CHDJQQJ99BJAC5RqLJAArohAAABAZBS474W.5TMCy3Dzi8AFAGrQIoWFO689tlDwx6HRBpCnoa0nDKrDLPOAt4wcJQQJ99BJAC5RqLJAArohAAABAZBS1YTB";
		const directLine = (window as any).WebChat.createDirectLine({ secret: directLineSecret });

		// directLine.connectionStatus$.subscribe(status => {
		// 	if (status === ConnectionStatus.Online) {
		// 		console.log("Conversation started:", directLine.conversationId);
		// 		localStorage.setItem('conversationId', directLine.conversationId);
		// 	}
		// });

		(window as any).WebChat.renderWebChat(
			{
				directLine,
				styleOptions: {
					hideUploadButton: true, // Hides the File Upload button
					bubbleBackground: '#0078d4',
					bubbleTextColor: 'white'
				}
			},
			document.getElementById('webchat')
		);
	}
}